/* global window */
import { getMetadata } from 'Selectors';
import { UI } from 'Reducers/ad/utils';
import { COMPONENT_SELECTOR_PREFIX } from 'Render/utils/importers';

const REGEX_FOR_SCRIPT_DOM_SELECTOR = /_ivoComponent\['(.*?)'\]/gi;
const REGEX_FOR_NAME_FROM_SCRIPT_DOM_SELECTOR = /'(.*)'/;

export const makeGetAssetUrl = (state) => {
  const assetPath = state.getIn([UI, 'assetPath']);
  const secure = state.getIn([UI, 'secure']);
  return (asset) => {
    const assetUrl = asset.asset_url;
    const isVideo = asset.mime_type.includes('video');

    if (assetPath && !isVideo) return `${assetPath}${asset.fileName}`;

    if (secure || (assetPath && isVideo)) return `https:${assetUrl}`;

    return assetUrl;
  };
};

export const sanitiseDataAttribute = (attribute) => {
  return typeof(attribute) !== 'undefined' ? attribute.replace(/\s+/g, '-').toLowerCase() : '';
};

export const makeGetAttributeFromAsset = (state) => {
  const getAssetUrl = makeGetAssetUrl(state);
  return (attribute, asset) => (asset ? { [attribute]: getAssetUrl(asset) } : { });
};

export const makeGetBackgroundImageFromImageAsset = (state) => {
  const getAssetUrl = makeGetAssetUrl(state);
  return imageAsset => (imageAsset ? { backgroundImage: `url(${getAssetUrl(imageAsset)})` } : { });
};

export const getComponentDOMId = (placementId, componentKey) =>
  `${COMPONENT_SELECTOR_PREFIX}-c-${placementId}-${componentKey}`;

export const getSafeClassFromName = (placementId, name) => {
  const trimmedName = name.replace(/\s+/g, '-');
  return `${COMPONENT_SELECTOR_PREFIX}-c-${placementId}-${trimmedName.toLowerCase()}`;
};

export const getSafeClassFromArray = (placementId, arrayString) => {
  const array = arrayString.split(',');
  [...array].forEach((itm, index) => {
    array[index] = getSafeClassFromName(0, itm);
  });
  return array.join();
};

export const getSafeClassFromStateAndComponent = (state, component) =>
  getSafeClassFromName(getMetadata(state).get('placementId'), component.getIn(['settings', 'name']));

export const getComponentDOMIdFromState = (state, componentKey) =>
  getComponentDOMId(getMetadata(state).get('placementId'), componentKey);

export const getNameFromDOMSelector = selector =>
  selector.match(REGEX_FOR_NAME_FROM_SCRIPT_DOM_SELECTOR)[1];

export const getDOMSelectors = script =>
  script.match(REGEX_FOR_SCRIPT_DOM_SELECTOR) || [];

export const replaceSelectors = (string, placementId) => {
  const scriptDomSelectors = getDOMSelectors(string);

  return scriptDomSelectors.reduce((memo, selector) =>
    memo.replace(selector, `.${getSafeClassFromName(placementId, getNameFromDOMSelector(selector))}`)
  , string);
};

export const getElementFromEvent = e =>
  (e ? (e.target || e.srcElement) : window.event.srcElement);

export const createStore = (reducer, initialState) => {
  let state = initialState;
  let listeners = [];

  const getState = () => state;

  const dispatch = (action) => {
    state = reducer(state, action);
    listeners.forEach(listener => listener(state, action));
  };

  const subscribe = (listener) => {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  };

  return { getState, subscribe, dispatch };
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/utils/index.js